'use client';
import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const slides = [
    {
        image: '/images/hero-bg.png',
        title: 'Junction Integrated Logistics',
        description: 'Building the comprehensive carrier of the future'
    },
    {
        image: '/images/hero2.jpg',
        title: 'Local Expertise, National Reach',
        description: 'Connecting businesses with reliable shipping services'
    },
    {
        image: '/images/hero3.jpg',
        title: 'Innovative Supply Chain',
        description: 'Reducing complexity through technology and comprehensive solutions'
    }
];

const Hero = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false
    };

    return (
        <div className="relative h-[70vh]">
            <Slider {...settings}>
                {slides.map((slide, index) => (
                    <div key={index} className="relative h-[70vh]">
                        {/* Background Image */}
                        <div className="absolute inset-0">
                            <img
                                src={slide.image}
                                alt="Logistics Background"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/50"></div>
                        </div>

                        {/* Content */}
                        <div className="relative h-full">
                            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
                                <div className="lg:w-2/3">
                                    <div className="animate__animated animate__fadeIn">
                                        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
                                            {slide.title}
                                        </h1>
                                        <p className="text-xl text-gray-200 mb-8">
                                            {slide.description}
                                        </p>
                                    </div>
                                    <div className="flex flex-col sm:flex-row gap-4 animate__animated animate__fadeInUp">
                                        <Link to="/contact" className="btn-primary">
                                            Get in Touch
                                        </Link>
                                        <Link to="/services" className="btn-secondary border-white text-white hover:bg-white hover:text-gray-900">
                                            Our Services
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>

            {/* Custom Dots Styling */}
            <style>{`
                .slick-dots {
                    bottom: 25px;
                }
                .slick-dots li button:before {
                    color: white;
                    opacity: 0.5;
                    font-size: 8px;
                }
                .slick-dots li.slick-active button:before {
                    color: white;
                    opacity: 1;
                }
            `}</style>
        </div>
    );
};

export default Hero; 